









type svgElement = SVG.Element | undefined

import Vue from 'vue'
import { Route } from 'vue-router'
import SVG from 'svg.js'
import 'svg.easing.js'

export default Vue.extend({
  data() {
    return {
      path: `
        <g id="en-name" data-name="レイヤー 1">
          <path class="cls-1" d="M17.66,97.94H15V97h6.4v1H18.79v7.7H17.66Z"/>
          <path class="cls-1" d="M31.05,101.22c0,3-1.81,4.56-4,4.56s-3.89-1.77-3.89-4.39,1.71-4.54,4-4.54S31.05,98.66,31.05,101.22Zm-6.71.14c0,1.85,1,3.51,2.76,3.51s2.77-1.63,2.77-3.6c0-1.72-.9-3.51-2.76-3.51S24.34,99.46,24.34,101.36Z"/>
          <path class="cls-1" d="M34.11,97h1.11v4.17h0c.23-.34.46-.64.68-.93L38.59,97H40l-3.13,3.67,3.38,5H38.89l-2.84-4.25-.83,1v3.3H34.11Z"/>
          <path class="cls-1" d="M43.79,97v8.65H42.67V97Z"/>
          <path class="cls-1" d="M47.35,105.64V97h1.21l2.78,4.37a25.61,25.61,0,0,1,1.55,2.81h0c-.11-1.15-.13-2.21-.13-3.55V97h1.05v8.65H52.71L50,101.25a26.3,26.3,0,0,1-1.61-2.89h0c.06,1.09.09,2.13.09,3.57v3.7Z"/>
          <path class="cls-1" d="M64.79,101.22c0,3-1.81,4.56-4,4.56s-3.88-1.77-3.88-4.39,1.7-4.54,4-4.54S64.79,98.66,64.79,101.22Zm-6.71.14c0,1.85,1,3.51,2.76,3.51s2.77-1.63,2.77-3.6c0-1.72-.9-3.51-2.76-3.51S58.08,99.46,58.08,101.36Z"/>
          <path class="cls-1" d="M16.61,115.78A16.39,16.39,0,0,1,19,115.6a4.94,4.94,0,0,1,3.5,1.08,4,4,0,0,1,1.22,3.1,4.62,4.62,0,0,1-1.24,3.37,5.39,5.39,0,0,1-3.83,1.24,19.35,19.35,0,0,1-2-.1Zm1.12,7.65a7.24,7.24,0,0,0,1.13.06,3.32,3.32,0,0,0,3.68-3.67c0-2-1.14-3.33-3.5-3.33a6.77,6.77,0,0,0-1.31.11Z"/>
          <path class="cls-1" d="M31.25,120.26H27.89v3.12h3.74v.93H26.77v-8.65h4.67v.94H27.89v2.73h3.36Z"/>
          <path class="cls-1" d="M34.54,123a3.93,3.93,0,0,0,2,.57c1.14,0,1.81-.6,1.81-1.48s-.46-1.27-1.63-1.72c-1.41-.5-2.28-1.23-2.28-2.45s1.11-2.35,2.79-2.35a3.94,3.94,0,0,1,1.92.43l-.31.91a3.37,3.37,0,0,0-1.64-.41c-1.19,0-1.63.7-1.63,1.29,0,.81.52,1.21,1.72,1.67,1.46.57,2.2,1.27,2.2,2.54s-1,2.49-3,2.49a4.43,4.43,0,0,1-2.2-.55Z"/>
          <path class="cls-1" d="M43.75,115.66v8.65H42.63v-8.65Z"/>
          <path class="cls-1" d="M53.88,123.93a8,8,0,0,1-2.65.47A4.05,4.05,0,0,1,46.79,120a4.34,4.34,0,0,1,4.68-4.47,5.35,5.35,0,0,1,2.16.4l-.27.91a4.56,4.56,0,0,0-1.91-.37A3.24,3.24,0,0,0,48,120a3.17,3.17,0,0,0,3.34,3.49,3.55,3.55,0,0,0,1.48-.23v-2.58H51v-.9h2.84Z"/>
          <path class="cls-1" d="M57.2,124.31v-8.65h1.22L61.19,120a24.91,24.91,0,0,1,1.56,2.81h0c-.1-1.16-.13-2.21-.13-3.56v-3.62H63.7v8.65H62.57l-2.75-4.38A29.3,29.3,0,0,1,58.2,117h0c.07,1.09.09,2.13.09,3.57v3.69Z"/>
          <path class="cls-1" d="M13.19,142.71a5.64,5.64,0,0,1-2.29.41,4,4,0,0,1-4.27-4.38,4.31,4.31,0,0,1,4.52-4.54,4.49,4.49,0,0,1,2,.39l-.27.91a4,4,0,0,0-1.74-.36,3.21,3.21,0,0,0-3.38,3.56,3.14,3.14,0,0,0,3.32,3.48,4.45,4.45,0,0,0,1.83-.36Z"/>
          <path class="cls-1" d="M23.83,138.58c0,3-1.81,4.55-4,4.55s-3.89-1.77-3.89-4.39,1.7-4.54,4-4.54S23.83,136,23.83,138.58Zm-6.71.14c0,1.84,1,3.5,2.76,3.5s2.77-1.63,2.77-3.59c0-1.72-.9-3.52-2.76-3.52S17.12,136.82,17.12,138.72Z"/>
          <path class="cls-1" d="M34.7,139.19c-.07-1.2-.15-2.65-.13-3.73h0c-.3,1-.66,2.09-1.09,3.28l-1.53,4.2h-.85l-1.4-4.12c-.41-1.22-.75-2.34-1-3.36h0c0,1.08-.09,2.53-.17,3.82L28.24,143H27.17l.61-8.65H29.2l1.48,4.18c.36,1.07.65,2,.87,2.92h0c.22-.88.53-1.82.91-2.92L34,134.34h1.43L36,143H34.91Z"/>
          <path class="cls-1" d="M39.85,134.44a13,13,0,0,1,2.14-.16,3.54,3.54,0,0,1,2.43.72,2.34,2.34,0,0,1,.75,1.81,2.56,2.56,0,0,1-.66,1.84,3.6,3.6,0,0,1-2.65.95,4.16,4.16,0,0,1-.9-.07V143H39.85ZM41,138.61a3.57,3.57,0,0,0,.93.09c1.35,0,2.17-.65,2.17-1.84s-.81-1.7-2-1.7a4.88,4.88,0,0,0-1.06.09Z"/>
          <path class="cls-1" d="M49.12,140.27l-.9,2.72H47.06L50,134.34h1.35L54.3,143H53.11l-.93-2.72ZM52,139.4l-.84-2.49c-.2-.57-.32-1.08-.45-1.58h0c-.13.51-.27,1-.43,1.56l-.85,2.51Z"/>
          <path class="cls-1" d="M57.7,143v-8.65h1.21l2.78,4.38a23.9,23.9,0,0,1,1.55,2.81h0c-.1-1.16-.12-2.21-.12-3.56v-3.62h1V143H63.06l-2.75-4.39a26.3,26.3,0,0,1-1.61-2.89l0,0c.06,1.09.09,2.13.09,3.57V143Z"/>
          <path class="cls-1" d="M70.1,143v-3.67l-2.73-5h1.27l1.21,2.39c.34.65.6,1.18.87,1.78h0c.24-.56.54-1.13.87-1.78l1.25-2.39h1.27l-2.9,5V143Z"/>
        </g>
        <g id="sun">
          <path class="cls-1" d="M41.24,44.08A13.31,13.31,0,1,1,54.56,30.77,13.32,13.32,0,0,1,41.24,44.08Zm0-23.79A10.49,10.49,0,1,0,51.73,30.77,10.49,10.49,0,0,0,41.24,20.29Z"/>
          <rect class="cls-1" x="39.83" width="2.83" height="7.62"/>
          <rect class="cls-1" x="39.83" y="53.92" width="2.83" height="7.62"/>
          <rect class="cls-1" x="10.47" y="29.36" width="7.62" height="2.83"/>
          <rect class="cls-1" x="64.39" y="29.36" width="7.62" height="2.83"/>
          <rect class="cls-1" x="18.28" y="48.2" width="8.26" height="2.83" transform="translate(-28.52 30.37) rotate(-45)"/>
          <rect class="cls-1" x="55.95" y="10.52" width="8.26" height="2.83" transform="translate(9.16 45.98) rotate(-45)"/>
          <rect class="cls-1" x="58.67" y="45.48" width="2.83" height="8.26" transform="translate(-17.48 57.02) rotate(-45.01)"/>
          <rect class="cls-1" x="20.99" y="7.8" width="2.83" height="8.26" transform="translate(-1.88 19.33) rotate(-44.99)"/>
        </g>
        <rect id="line" class="cls-1" y="159.11" width="82.49" height="2.83"/>
        <g id="jp-name">
          <rect class="cls-1" x="20.1" y="196.78" width="3.32" height="3.74"/>
          <polygon class="cls-1" points="30.03 220.65 26.58 220.65 26.41 220.74 30.29 229.08 14.36 229.08 23.05 210.87 19.38 210.87 9.13 232.4 35.5 232.4 30.03 220.65"/>
          <polygon class="cls-1" points="5.35 201.72 5.35 225.77 1.4 233.86 5.09 233.86 8.67 226.54 8.67 205.03 35.51 205.03 35.51 201.72 5.35 201.72"/>
          <rect class="cls-1" x="19.28" y="239.47" width="3.32" height="17.03"/>
          <rect class="cls-1" x="23.84" y="244.46" width="10.34" height="3.32"/>
          <rect class="cls-1" x="7.67" y="244.46" width="13.99" height="3.32"/>
          <rect class="cls-1" x="0.64" y="254.1" width="38.1" height="3.36"/>
          <rect class="cls-1" x="6.04" y="261.49" width="3.32" height="15.05"/>
          <polygon class="cls-1" points="33.69 275.24 30.38 275.24 30.38 264.86 10.66 264.86 10.66 261.54 33.69 261.54 33.69 275.24"/>
          <rect class="cls-1" x="10.66" y="271.92" width="22.88" height="3.32"/>
          <polygon class="cls-1" points="7.11 241.49 2.74 250.5 6.42 250.5 10.8 241.49 7.11 241.49"/>
          <rect class="cls-1" x="13.65" y="300.53" width="3.32" height="6.07" transform="translate(-210.14 99.7) rotate(-44.99)"/>
          <rect class="cls-1" x="6.44" y="281.94" width="3.32" height="3.7"/>
          <polygon class="cls-1" points="9.76 318.88 6.44 318.88 6.44 302.46 9.76 298.95 9.76 318.88"/>
          <rect class="cls-1" x="25.14" y="281.94" width="3.32" height="34.07"/>
          <rect class="cls-1" x="16.4" y="314.26" width="22.32" height="3.32"/>
          <rect class="cls-1" x="29.7" y="292.53" width="7.48" height="3.32"/>
          <rect class="cls-1" x="17.34" y="292.53" width="8.23" height="3.32"/>
          <polygon class="cls-1" points="0.59 286.91 0.59 290.23 12.18 290.23 12.18 289.98 0.49 302.1 0.49 306.88 15.49 291.32 15.49 286.91 0.59 286.91"/>
          <path class="cls-1" d="M69.3,272.36l5.38-8.92c1.86-3.53,2.84-8.69-.47-11.63l-.08-.07A13,13,0,0,0,54.05,268l.06.1,7.34-15.52h3.94L56,272.36H53a16.54,16.54,0,0,1,23.59-23.18c4.83,4.33,3.67,11.31,1.2,16l0,.09-4.3,7.12Z"/>
          <polygon class="cls-1" points="48.49 232.44 45.17 232.44 45.17 201.56 57.47 201.56 57.47 230.68 54.15 230.68 54.15 204.88 48.49 204.88 48.49 232.44"/>
          <rect class="cls-1" x="68.48" y="196.86" width="3.32" height="16.43"/>
          <polygon class="cls-1" points="77.16 237.21 68.69 237.21 67.1 233.9 73.85 233.9 73.85 215.07 77.16 215.07 77.16 237.21"/>
          <rect class="cls-1" x="49.74" y="213.88" width="5.72" height="3.32"/>
          <rect class="cls-1" x="60.78" y="201.64" width="9.71" height="3.32"/>
          <rect class="cls-1" x="59.07" y="210.91" width="23.99" height="3.32"/>
          <rect class="cls-1" x="59.07" y="220.39" width="16.8" height="3.32"/>
          <rect class="cls-1" x="78.42" y="220.39" width="4.63" height="3.32"/>
          <rect class="cls-1" x="73.01" y="201.64" width="7.87" height="3.32"/>
          <rect class="cls-1" x="49.74" y="226.16" width="5.72" height="3.32"/>
          <rect class="cls-1" x="64.67" y="225.26" width="3.32" height="4.71" transform="translate(-86.01 45.96) rotate(-23.74)"/>
        </g>
      `,
      viewBoxHeight: 319.1,
      draw: undefined as SVG.Doc | undefined,
      sun: undefined as svgElement,
      line: undefined as svgElement,
      enName: undefined as svgElement,
      jpName: undefined as svgElement,
      mask: undefined as svgElement,
      maskRect: undefined as svgElement
    }
  },
  mounted() {
    this.draw = SVG('logo').size(83.13, this.viewBoxHeight).svg(this.path)
    this.jpName = SVG.get('jp-name')
    this.sun = SVG.get('sun')
    this.enName = SVG.get('en-name')
    this.line = SVG.get('line')
    this.mask = this.draw.mask().add(this.sun)
    this.maskRect = this.draw.rect(83.13, this.line.bbox().y).fill('#000')
    this.animation()
    
    if (this.$route.name !== 'home') {
      this.jpName.attr({ opacity: 0 })
      this.draw.size(83.13, 160)
    }
  },
  watch: {
    $route(to: Route) {
      (this.jpName as SVG.Element).animate({ ease: '<>', duration: 1000 }).attr({ opacity: to.name !== 'home' ? 0 : 1})
    }
  },
  methods: {
    animation() {
      (this.enName as SVG.Element).attr({ opacity: 0 });
      (this.sun as SVG.Element).attr({ fill: '#fff', opacity: 0 }).translate(0, this.viewBoxHeight + (this.sun as SVG.Element).bbox().height);
      (this.maskRect as SVG.Element).maskWith((this.mask as SVG.Element));
      (this.sun as SVG.Element).animate({ ease: '<>', duration: 2000 }).attr({ opacity: 1 }).translate(0, 0).after(() => {
        (this.enName as SVG.Element).animate({ ease: '>', duration: 2000, delay: 1000 }).attr({ opacity: 1 }).after(() => {
          this.loopAnimation()
        })
      })
    },
    loopAnimation() {
      const duration = 8000;
      (this.maskRect as SVG.Doc).animate({ duration }).attr({ fill: '#E35348' });
      (this.enName as SVG.Doc).animate({ duration }).attr({ fill: '#E35348' });
      (this.line as SVG.Doc).animate({ duration }).attr({ fill: '#E35348' }).after(() => {
        (this.maskRect as SVG.Doc).animate({ duration, delay: 1000 }).attr({ fill: '#000' });
        (this.enName as SVG.Doc).animate({ duration, delay: 1000 }).attr({ fill: '#000' });
        (this.line as SVG.Element).animate({ duration, delay: 1000 }).attr({ fill: '#000' }).after(() => {
          this.loopAnimation()
        })
      })
    }
  }
})
